module.exports = __webpack_public_path__ + "images/icons/flags/PL-2142f7c5.svg";